import { combineReducers } from 'redux';

import ads from './ads/reducer';
import bankId from './bank-id/reducer';
import { reducer as categories } from './categories/reducer';
import { reducer as discover } from './discover/reducer';
import { reducer as environment } from './environment/reducer';
import initData from './init-data/reducer';
import items from './items/reducer';
import language from './language/reducer';
import member from './member/reducer';
import multiCurrency from './multi-currency/reducer';
import page from './page/reducer';
import { reducer as personalisation } from './personalisation/reducer';
import pushNotifications from './push-notifications/push-notifications-slice';
import shippingRegion from './shipping-region/reducer';
import { reducer as ui } from './ui/reducer';
import views from './views/reducer';
import { connectRouter } from 'connected-react-router';
import { reducer as status } from './status/reducer';
import { discoverApi } from './services/discover-api';
import { feesApi } from './services/fees-api';
import { touchwebSearchApi } from './services/touchweb-search-api';
import { touchwebSyiApi } from './services/touchweb-syi-api';
import { wishListNudge } from './wish-list-nudge/reducer';
import { shoppingApi } from './services/shopping-api';
import type { History } from 'history';
import { bidHistoryApi } from 'tradera/components/bid-history/bid-history-api';
import { cartApi } from './services/cart-api';
import { draftsApi } from 'tradera/apps/syi/state/drafts-api';
import { templatesApi } from 'tradera/apps/syi/state/templates-api';
import { shippingComplaintApi } from './services/shipping-complaint-api';
import { savedSearchesApi } from 'tradera/apps/my-tradera/saved-searches/saved-searches-api';
import { pickListApi } from 'tradera/apps/my-tradera/pick-list2/services/pick-list-api';
import { reducer as request } from './request/reducer';
import { reducer as random } from './random/reducer';

const rootReducer = (history: History) =>
    combineReducers({
        ads,
        bankId,
        categories,
        discover,
        environment,
        initData,
        items,
        language,
        member,
        multiCurrency,
        page,
        personalisation,
        pushNotifications,
        random,
        request,
        shippingRegion,
        ui,
        views,
        wishListNudge,
        router: connectRouter(history),
        status,
        [discoverApi.reducerPath]: discoverApi.reducer,
        [feesApi.reducerPath]: feesApi.reducer,
        [pickListApi.reducerPath]: pickListApi.reducer,
        [touchwebSearchApi.reducerPath]: touchwebSearchApi.reducer,
        [touchwebSyiApi.reducerPath]: touchwebSyiApi.reducer,
        [shoppingApi.reducerPath]: shoppingApi.reducer,
        [bidHistoryApi.reducerPath]: bidHistoryApi.reducer,
        [cartApi.reducerPath]: cartApi.reducer,
        [draftsApi.reducerPath]: draftsApi.reducer,
        [templatesApi.reducerPath]: templatesApi.reducer,
        [shippingComplaintApi.reducerPath]: shippingComplaintApi.reducer,
        [savedSearchesApi.reducerPath]: savedSearchesApi.reducer
    });

export default rootReducer;
